export const TOOL_TASK = 'assign-product-account-entitlements';
export const TOOL_TITLE = 'Assign Account Resources';
export const TOOL_PROGRESS_LABEL = 'Progress of assigning resources to the account...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once assigning resources to the account finishes';
export const CONFLICT_TOOL_TITLE = 'Conflicting grants on resource';
export const MODAL_WIDTH = 800;
